<script>

export default {
    data() {
        return {
            recaptchaCheckInterval: null,
        };
    },
    mounted() {
        this.waitForRecaptcha();
    },
    beforeDestroy() {
        if (this.recaptchaCheckInterval) {
            clearInterval(this.recaptchaCheckInterval);
        }
        delete window.onCaptchaVerified;
    },
    methods: {
        waitForRecaptcha() {
            this.recaptchaCheckInterval = setInterval(() => {
                if (window.grecaptcha) {
                    clearInterval(this.recaptchaCheckInterval);
                    this.recaptchaCheckInterval = null;
                    this.initRecaptcha();
                }
            }, 100);
        },
        initRecaptcha() {
            window.grecaptcha.ready(() => {
                this.recaptchaSiteKey = window.recaptchaSiteKey;
                this.executeCaptcha();
            });
        },
        executeCaptcha() {
            window.grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' })
                .then((token) => {
                    this.onCaptchaVerified(token);
                })
                .catch((error) => {
                    console.error("reCAPTCHA v3 execution error:", error);
                });
        },
        onCaptchaVerified(token) {
            this.$emit('verified', token);
        },
    },
};
</script>

<style scoped>
.g-recaptcha {
    display: inline-block;
}
</style>
